<script lang="ts">
    import { onMount } from "svelte";
    import { useNavigate } from "svelte-navigator";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { campaignWrapperStore } from "../../../../store";
    import { campaignStore } from "../../../../store/campaigns";
    import { user } from "../../../../store/stores";
    import CampaignCard from "./Components/CampaignCard.svelte";

    const navigate = useNavigate();

    const getCampaignWrappers = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .campaignWrapperClient.listCampaignWrappers({ size: 25 })
                .then((campaignWappers) =>
                    campaignWrapperStore.update((campaignWrapperStore) => {
                        return {
                            ...campaignWrapperStore,
                            campaignWrappers: campaignWappers,
                        };
                    })
                );
        });
    };

    onMount(() => getCampaignWrappers());
</script>

<div class="columns is-multiline">
    <div class="column is-12">
        <div class="card sticky">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-vcentered is-multiline">
                        <div class="column is-2">
                            <p
                                class="is-5 greenish-plus"
                                on:click={() => navigate("new")}
                            >
                                +
                            </p>
                        </div>
                        <div class="column is-3 ">
                            <p class="is-5 greenish">Kampagne</p>
                        </div>
                        <div class="column is-3 ">
                            <p class="greenish is-5">Dauer</p>
                        </div>
                        <div class="column is-3">
                            <p class="greenish is-5">Status</p>
                        </div>
                        {#if $campaignWrapperStore.campaignWrappers && $campaignWrapperStore.campaignWrappers.entries}
                            {#each $campaignWrapperStore.campaignWrappers.entries as campaignWrapper}
                                <CampaignCard campaignEntry={campaignWrapper} />
                            {/each}
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .sticky {
        position: sticky;
        top: 0rem;
        z-index: 100;
    }

    .column {
        text-align: center;
    }

    .card {
        border-radius: 100px;
        padding: 1rem;
        padding-bottom: 0;
    }

    .greenish {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }
</style>
